import Vue from "vue";
import Vuex from "vuex";

import base from "./base.js";
import beacons from "./beacons.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    base,
    beacons,
  },
});
